import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('plan-pagos-concepto-universidad'), data);
  },
  async update(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`plan-pagos-concepto-universidad/${id}`), data);
  },
  async order(data) {
    return await axiosIns.patch(obtenerUrlAPIPagos('plan-pagos-concepto-universidad/ordenar'), data);
  },
  async cambiarMonto(id, data) {
    return await axiosIns.post(obtenerUrlAPIPagos(`plan-pagos-concepto-universidad/${id}/cambiar-monto`), data);
  },
};
